"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
exports.CSS = {
    container: 'c-BearingInput',
    label: 'c-BearingInput__label'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        display: 'flex',
        'align-items': 'center'
    },
    _a);
//# sourceMappingURL=bearing.input.style.js.map